import clsx from 'clsx';
import { forwardRef } from 'react';
import './index.scss';

const OTPInput = forwardRef(
    (
        {
            maxLength = 6,
            value,
            onValueChange,
            onRefClick,
            className = '',
            inputClassName = '',
            enableAutoComplete = false,
            onToggleFocus,
            focused = true,
            autoFocus = true,
            isPin = false,
            isError= false
        },
        ref
    ) => {
        const defaultPinCodeList = Array(maxLength).fill('');
        const currentPinCodeList = value?.split('');

        const changeNumberValue = (e) => {
            const value = e.target.value.replace(/[^\d]/g, '');
            onValueChange(value);
        };

        return (
            <div className={`lite-otp-input ${className}`}>
                <div className="code-container">
                    {defaultPinCodeList.map((code, index) => (
                        <span
                            key={index}

                            className={clsx(`${inputClassName} gb_mask`, {
                                'active-code': value.length === index,
                                'focused-code': focused && value.length === index,
                                'error-code': isError
                            })}
                        >
                            {isPin ? <div className={(currentPinCodeList[index] || code) ? 'dot' : ''}></div> : (currentPinCodeList[index] || code)}
                            <div className="cursor" />
                        </span>
                    ))}
                </div>
                <input
                    ref={ref}
                    autoFocus={autoFocus}
                    value={value}
                    autoComplete={enableAutoComplete ? 'one-time-code' : 'off'}
                    inputMode="numeric"
                    maxLength={maxLength}
                    onClick={() => {
                        onRefClick?.()
                    }}
                    pattern={`"\d{${maxLength}}"`}
                    onChange={changeNumberValue}
                    onFocus={() => onToggleFocus?.(true)}
                    onBlur={() => onToggleFocus?.(false)}
                />
            </div>
        );
    }
);

export default OTPInput;
